import { render, staticRenderFns } from "./halfCircleTR.vue?vue&type=template&id=40e0afd2&"
import script from "./halfCircleTR.vue?vue&type=script&lang=js&"
export * from "./halfCircleTR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports